import React from "react";
import {  useMediaQuery, useTheme } from "@mui/material";
import { styled } from "@mui/material/styles";
import { generateTestId } from "../../../app/functions";
import { getMediaPath } from "../../../app/functions";
import MediaCarousel from "components/MediaCarousel";
import { HEADER_GALLERY_ASPECT_RATIO_DEFAULTS } from "constants/common";

const GalleryWrapper = styled('div')(({ theme, aspectRatioMobile, aspectRatioDesktop }) => ({
  '& .header-gallery': {
    width: '100%',
    aspectRatio: aspectRatioMobile,
    marginBottom: '30px',
    [theme.breakpoints.up("sm")]: {
      aspectRatio: aspectRatioDesktop,
    },
  }
}));

const HeaderGallery = ({ data, testID, onClick, onSlideClick, aspectRatioMobile = HEADER_GALLERY_ASPECT_RATIO_DEFAULTS.MOBILE, aspectRatioDesktop = HEADER_GALLERY_ASPECT_RATIO_DEFAULTS.DESKTOP }) => {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const slides = isMobile ? data.galleryMobile ? data.galleryMobile : data.galleryDesktop : data.galleryDesktop;

  const handleSlideClick = (slide, index) => {
    if (onSlideClick) {
      onSlideClick(slide, index);
    } else if (onClick) {
      onClick(slide, index);
    }
  };

  return (
    <GalleryWrapper aspectRatioMobile={aspectRatioMobile} aspectRatioDesktop={aspectRatioDesktop} testid={generateTestId(testID, "gallery-wrapper")}>
    {slides && (
      <MediaCarousel
            items={slides.map((slide) => ({
              id: slide.id,
              url: getMediaPath(slide.imagePath),
              link: slide.link,
              linkType: slide.linkType,
            }))}
            showNavigation={true}
            showPagination={true}
            onSlideClick={handleSlideClick}
            slidesPerView={1}
            delay={5000}
            className="header-gallery"
          />
    )}
      
    </GalleryWrapper>
  );
};

export default HeaderGallery;
